module.exports = require("@mui/icons-material/FiberManualRecord");